// @ts-nocheck
type valueWithUnit = { value: number; unit: string }

const DEFAULT_ROOT_FONT_SIZE_PX = 16

export const parseCssValueUnit = (value: string): valueWithUnit | null => {
  const match = /^([0-9]+|[0-9]*\.[0-9]+)([a-z%]+)$/.exec(
    value.trim().toLowerCase()
  )
  if (!match) {
    return null
  }

  return { value: Number(match[1]), unit: match[2] }
}

export const cssValueToPx = (
  valueWithUnit: string,
  baseFontSize = `${DEFAULT_ROOT_FONT_SIZE_PX}px`
): number => {
  const input = parseCssValueUnit(valueWithUnit)
  if (!input.value) {
    throw new Error(`Invalid CSS value: ${valueWithUnit}`)
  }

  if (input.unit === 'px') {
    return input.value
  }

  const base = parseCssValueUnit(baseFontSize)
  if (!base) {
    throw new Error(`Invalid CSS value: ${baseFontSize}`)
  }

  if (['em', 'rem'].includes(base.unit)) {
    base.value *= DEFAULT_ROOT_FONT_SIZE_PX
    base.unit = 'px'
  } else if (base.unit === '%') {
    base.value = (base.value / 100) * DEFAULT_ROOT_FONT_SIZE_PX
    base.unit = 'px'
  }

  if (base.unit !== 'px') {
    throw new Error(`Unsupported base value unit: '${base.unit}'`)
  }

  if (['em', 'rem'].includes(input.unit)) {
    return input.value * base.value
  }

  throw new Error(`Can’t convert: ${valueWithUnit}`)
}
